module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-avatar', {
    attrs: {
      "size": "35"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locale.image
    }
  })])], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(lang) {
    return _c('v-list-tile', {
      key: lang.key,
      on: {
        "click": function($event) {
          _vm.locale = lang
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(lang.name)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-avatar', {
      attrs: {
        "size": "35"
      }
    }, [_c('img', {
      attrs: {
        "src": lang.image
      }
    })])], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77c7be43","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/SelectLanguage.vue
// module id = 1069
// module chunks = 1